import RootPages from './pages/RootPages.vue'
import Home from './pages/Home.vue'

export default [
  {
    name: 'Home',
    path: '/',
    component: Home
  },
  {
    name: 'Page',
    path: '*',
    component: RootPages
  },
];